<template>
    <div>
        <Dashboard/>
    </div>
</template>~

<script>
   import Dashboard from '../components/userDashboard.vue'
    export default {
        name:"Task",
        components:{
            Dashboard
        }
    }
</script>
